// Re-export for backwards compatibility
export { WebSocketClientType } from '../types';

// Legacy alias
export { WebSocketClientType as WebsocketClientType } from '../types';
